
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
    name: "privacy-policy",
    components: {},
    setup() {
        const store = useStore();

    },
});
